import type { Builder } from "../../types.js";
import { buildHierarchyEndpoints } from "./hierarchyEndpoints.js";

export const buildCostCenterEndpoints = (builder: Builder) => ({
	...buildHierarchyEndpoints(builder),
});
